import { z } from 'zod'

import { ReportTemplateType } from '../dtos/report'

export const reportTemplateValidationSchema = z.object({
  name: z.string().trim().nonempty().min(3).max(255),
  description: z.string().max(1_000).optional(),
  instructions: z.string().min(3).trim().nonempty().max(50_000),
  type: z.enum(Object.values(ReportTemplateType) as [ReportTemplateType]),
})

export const reportTemplatesValidationSchema = z
  .array(reportTemplateValidationSchema)
  .min(1, { message: 'At least one report template is required' })
  .refine(
    (templates) => {
      const names = templates.map((t) => t.name.toLowerCase())
      return names.length === new Set(names).size
    },
    {
      message: 'Report template names must be unique (case insensitive)',
      path: ['name'],
    },
  )
